import React from 'react';

import { Wrapper } from './wrapper';

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  small?: boolean;
  children?: React.ReactNode;
};

const Content = ({ children, small, dangerouslySetInnerHTML }: Props) => {
  if (dangerouslySetInnerHTML) {
    return <Wrapper small={small} dangerouslySetInnerHTML={dangerouslySetInnerHTML} />;
  }

  return <Wrapper small={small}>{children}</Wrapper>;
};

export default Content;
